import { call, put, takeLatest } from 'redux-saga/effects'

import { postApplication, putApplication, deleteApplication } from '@galo-monitor/services/apis/galoMonitorApi/resources/application'

import { ApplicationActions, ApplicationTypes } from './duckApplication'

function* saveApplication({ application, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(application.id ? putApplication : postApplication , application)
    yield call(onSuccess)
  } catch (err) {
    yield put(ApplicationActions.applicationError(err.message))
    yield call(onError, err)
  }
}

function* removeApplication({ application, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(deleteApplication, application)
    yield call(onSuccess)
  } catch (err) {
    yield put(ApplicationActions.applicationError(err.message))
    yield call(onError, err)
  }
}

export default [
  takeLatest(ApplicationTypes.SAVE_APPLICATION, saveApplication),
  takeLatest(ApplicationTypes.REMOVE_APPLICATION, removeApplication)
]
